import { Component, OnInit, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { CustomField } from '../custom-field/custom-field-model';
import { map } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { CustomFieldEdit } from '../../contacts/custom-field-edit.model';
import { SubSink } from 'subsink';
declare var $: any;
declare var Toast: any;

@Component({
    selector: 'custom-field-assign',
    templateUrl: './custom-field-assign.component.html',
    styleUrls: ['./custom-field-assign.component.css']
})

export class CustomFieldAssignComponent implements OnInit, OnDestroy {

  private customFields: CustomField[] = [];
  private editCustomFields: CustomFieldEdit[] = [];
  private modal: any;
  private selectedContactList: number[] = [];
  private subs = new SubSink();

  @ViewChild('assignForm', { static: false }) assignForm: NgForm;

  @Output()
  private assigned: EventEmitter<number> = new EventEmitter<number>();

  constructor(private repository: HttpRepositoryService) { }

  ngOnInit() {
    this.modal = $('#assignCustomField');

    this.subs.sink = this.repository.get<CustomField[]>('api/CustomField/List').pipe(map(x => x.data))
      .subscribe(fields => {
        this.customFields = fields;
      });
  }

  public show(checked: number[]) {
    this.assignForm.reset();
    this.selectedContactList = checked;

    var fields: CustomFieldEdit[] = [];
    for (var i = 0; i < this.customFields.length; i++) {
      var edit = new CustomFieldEdit();
      edit.id = this.customFields[i].id;
      edit.name = this.customFields[i].name;
      edit.type = this.customFields[i].type;
      fields.push(edit);
    }

    this.editCustomFields = fields;

    this.modal.modal({
      show: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  close() {
    this.modal.modal('hide');
  }

  save() {
    let selected = this.editCustomFields.filter(x => x.isChecked).map(x => ({ idCustomField: x.id, isRequired: x.isRequired ? true : false }));

    let data = {
      idContactLists: this.selectedContactList,
      customFields: selected
    }

    this.subs.sink = this.repository.post<any>('api/ContactList/Assign', data).subscribe(resp => {
          if (resp.hasErrors) {
              Toast.Show(resp.error, 'Assign custom field(s)', 'error');
          } else {
              Toast.Show('Custom field(s) assigned successfully.', 'Assign custom field(s)', 'success');
          }

          this.onSaveCompleted(resp.data);
     });
  }

  private onSaveCompleted(data: number) {
    this.close();
    this.assigned.emit(data);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
